/**
 * Imports
 */
import * as React from 'react';
import baseStyled, {
  ThemedStyledInterface,
  ThemeProvider as BaseThemeProvider,
  createGlobalStyle,
} from 'styled-components';

import { VibrantColors } from './colors';
import { Transitions } from './transitions';

/**
 * GloblaStyle
 */
const GlobalStyle = createGlobalStyle`
  body,
  html {
    font-family: 'BasierRegular', apple-system, BlinkMacSystemFont, 'Segoe UI',
  Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
    font-style: normal;
    font-weight: normal;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%
  }
  #root {
  height: 100%
}
  span {
    display: block;
  }
  /* Antd message override styling / Global snackbar */
  .vibrant-error-message .ant-message-notice-content {
    background-color:  ${VibrantColors.Message.Danger};
    color: ${VibrantColors.Text.Danger}
  }
  .vibrant-warning-message .ant-message-notice-content {
    background-color:  ${VibrantColors.Message.Warning};
    color: ${VibrantColors.Text.Warning}
  }
  .vibrant-success-message .ant-message-notice-content {
    background-color:  ${VibrantColors.Message.Success};
    color: ${VibrantColors.Text.Success}
  }
  .vibrant-info-message .ant-message-notice-content {
   background-color: ${VibrantColors.Message.Info};
   color: ${VibrantColors.Text.Info}
  }
  .ant-message-notice-content {
    font-weight: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20.8px;
    box-shadow: 0px 2px 8px rgba(20, 20, 20, 0.1);
    border-radius: 4px;
    padding: 12px 24px;
  }
  .ant-message-custom-content {
    display: flex;
    align-items: center;
  }
  .ant-message-notice-content .anticon-info-circle {
    display: none;
  }
`;

/**
 * Theme
 */
const theme = {
  Vibrant: {
    Colors: VibrantColors,
    Transitions,
  },
};

/**
 * Types
 */
export type VibrantTheme = typeof theme;

/**
 * `styled` object for themed styled-components
 */
const styled: ThemedStyledInterface<VibrantTheme> = baseStyled;
const ThemeProvider: React.FC = ({ children }) => (
  <>
    <GlobalStyle />
    <BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>
  </>
);

/**
 * Exports
 */
export { theme, styled, ThemeProvider, Transitions, VibrantColors };
